export enum WIDGET_MENU_OPTIONS {
  NONE = '',
  TEMPLATES = 'widget-menu-templates',
  TEXT = 'widget-menu-text',
  ICONS = 'widget-menu-icons',
  PHOTOS = 'widget-menu-photos',
  UPLOAD = 'widget-menu-upload',
  SMART = 'widget-menu-smart',
  SHAPES = 'widget-menu-shapes',
  CHARTS = 'widget-menu-charts',
  ELEMENTS = 'widget-menu-elements',
  REPLACE = 'widget-menu-replace',
  QR_CODE = 'widget-menu-qr-code',
  MAPS = 'widget-menu-maps',
  BRAND_KIT = 'widget-menu-brand-kit',
  IMAGES = 'widget-menu-images',
}
